export default __webpack_public_path__ + "static/media/mingcute_down-line.b356cd5e.svg";